export default __webpack_public_path__ + "static/210528_夏日角色熱更預告_kr-a8f2fcb4ca4b69007028d7a019e01127.webp";